/** localStorage key for dashboard calendar density (month grid vs compact week strip). */
export const CALENDAR_VIEW_MODE_STORAGE_KEY = "mighty45-client-console-calendar-view-mode";

/** @returns {"month" | "week"} */
export function readStoredCalendarViewMode() {
  try {
    if (typeof window === "undefined") return "month";
    const v = window.localStorage.getItem(CALENDAR_VIEW_MODE_STORAGE_KEY);
    return v === "week" ? "week" : "month";
  } catch {
    return "month";
  }
}

/** @param {"month" | "week"} mode */
export function writeStoredCalendarViewMode(mode) {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(CALENDAR_VIEW_MODE_STORAGE_KEY, mode);
  } catch {
    /* ignore quota / privacy mode */
  }
}
